import React from "react";

export const ConsultantSkeleton = () => {
  return (
    <div className="bg-white rounded-xl border border-gray-100 overflow-hidden flex flex-col h-full">
      {/* Header: Avatar + Name */}
      <div className="flex items-center px-4 py-4 gap-3">
        <div className="w-12 h-12 rounded-full bg-gray-200 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="h-4 w-32 bg-gray-200 rounded-md" />
          <div className="h-3 w-40 bg-gray-200 rounded-md mt-2" />
        </div>
        <div className="h-4 w-4 bg-gray-200 rounded flex-shrink-0" />
      </div>

      {/* Divider */}
      <hr className="border-gray-100" />

      {/* Specialization Chips */}
      <div className="px-4 py-3">
        <div className="h-3 w-20 bg-gray-200 rounded-md mb-2" />
        <div className="flex flex-wrap gap-1.5">
          <div className="h-6 w-24 bg-gray-200 rounded-full" />
          <div className="h-6 w-20 bg-gray-200 rounded-full" />
          <div className="h-6 w-16 bg-gray-200 rounded-full" />
        </div>
      </div>

      {/* Divider */}
      <hr className="border-gray-100" />

      {/* Footer: Experience + Price */}
      <div className="flex items-center justify-between px-4 py-3 mt-auto">
        <div className="flex flex-col gap-1.5">
          <div className="h-3 w-36 bg-gray-200 rounded-md" />
          <div className="h-3 w-28 bg-gray-200 rounded-md" />
        </div>
        <div className="flex flex-col items-end gap-1">
          <div className="h-3 w-14 bg-gray-200 rounded-md" />
          <div className="h-5 w-20 bg-gray-200 rounded-md" />
        </div>
      </div>
    </div>
  );
};
